import * as React from 'react';
import { useEffect } from 'react';

import { useTracker } from '@coursera/event-pulse/react';

import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';
import type { ProductType } from 'bundles/unified-description-page-common/contexts/EventingContext';
import EventingContext from 'bundles/unified-description-page-common/contexts/EventingContext';

const EventingDataProvider = ({
  productId,
  productType,
  children,
}: {
  productId: string;
  productType: ProductType;
  children: React.ReactNode;
}) => {
  const track = useTracker();
  const org = useThirdPartyOrganization();
  const program = useProgram();
  const enterpriseContext =
    org?.slug || program?.metadata.slug
      ? {
          enterprise: {
            ...(org?.slug ? { organizationSlug: org.slug } : {}),
            ...(program?.metadata.slug ? { programSlug: program?.metadata.slug } : {}),
          },
        }
      : {};
  useEffect(
    () => {
      track('view_description_page', {
        descriptionPageApp: 'xdp',
        product: {
          id: productId,
          type: productType,
        },
        ...enterpriseContext,
      });
    }, // FIXME: existing react-hooks/exhaustive-deps violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [productId, productType]
  );

  return (
    <EventingContext.Provider
      value={{
        product: {
          id: productId,
          type: productType,
        },
      }}
    >
      {children}
    </EventingContext.Provider>
  );
};

export default EventingDataProvider;
